import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { TextInput } from './text-input';

const styles = makeStyles({
  input: {
    '&:hover': {
      '&:not(.Mui-disabled)': {
        '&::before': {
          border: 0,
        },
      },
    },
    '&::before': {
      border: 0,
    },
    '&::after': {
      border: 0,
    },
  },
});

function NakedInput(props) {
  const classes = styles();

  return (
    <TextInput variant="standard" InputProps={{ classes: { root: classes.input } }} {...props} />
  );
}

export { NakedInput };
